/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-03-25",
    versionChannel: "nightly",
    buildDate: "2023-03-25T00:20:25.477Z",
    commitHash: "f6a139235bdb9e1a03548a444222f5bb77414149",
};
